var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagBg = function SvgIconFlagBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M4.465 9.333h15.07A8 8 0 0 0 12.005 4h-.011c-3.48.003-6.43 2.23-7.53 5.334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00966E",
    d: "M4 12c0 .937.169 1.832.465 2.667h15.07A8 8 0 0 0 20 12c0-.937-.169-1.831-.465-2.666H4.465A8 8 0 0 0 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C22328",
    d: "M19.535 14.666H4.465c1.098 3.103 4.05 5.33 7.528 5.333h.014c3.478-.004 6.43-2.23 7.528-5.333"
  }))));
};
export { SvgIconFlagBg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGQ9Ik00LjQ2NSA5LjMzM2gxNS4wN0E3Ljk5NyA3Ljk5NyAwIDAwMTIuMDA1IDRoLS4wMTFjLTMuNDguMDAzLTYuNDMgMi4yMy03LjUzIDUuMzM0IiBmaWxsPSIjRkVGRUZFIi8+PHBhdGggZmlsbD0iIzAwOTY2RSIgZD0iTTQgMTJjMCAuOTM3LjE2OSAxLjgzMi40NjUgMi42NjdoMTUuMDdBNy45NiA3Ljk2IDAgMDAyMCAxMmMwLS45MzctLjE2OS0xLjgzMS0uNDY1LTIuNjY2SDQuNDY1QTcuOTU0IDcuOTU0IDAgMDA0IDEyIi8+PHBhdGggZD0iTTE5LjUzNSAxNC42NjZINC40NjVjMS4wOTggMy4xMDMgNC4wNSA1LjMzIDcuNTI4IDUuMzMzaC4wMTRjMy40NzgtLjAwNCA2LjQzLTIuMjMgNy41MjgtNS4zMzMiIGZpbGw9IiNDMjIzMjgiLz48L2c+PC9zdmc+";